import reduxCrud from 'redux-crud';

const groupsReducers = reduxCrud.Map.reducersFor('groups', { key: '_id' });

export default groupsReducers;
